import React from 'react';
import { browserHistory } from 'react-router';
import querystring from 'query-string';
import { Container, Row, Col } from 'reactstrap';
import auth from './auth';

class Auth extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null
        };
    }

    componentDidMount() {
        const query = querystring.parse(window.location.search.substring(1));
        if (query.error) {
            let redirect;
            switch (query.error) {
                case 'login_required':
                case 'interaction_required':
                    redirect = window.sessionStorage.getItem('authorize_url');
                    break;
                default:
                    break;
            }
            if (redirect) {
                window.location = redirect;
            } else {
                this.setState({
                    error: query.error_description
                });
            }
            return;
        } else {
            window.sessionStorage.removeItem('authorize_url');
        }

        const hash = window.location.hash.substring(1);
        const hashQuery = querystring.parse(hash);

        const state = window.sessionStorage.getItem('state');
        if (hashQuery.state !== state) {
            this.setState({
                error: 'Invalid state'
            });
            return;
        }
        window.sessionStorage.removeItem('state');

        window.sessionStorage.removeItem('nonce'); //@TODO verify


        if (hashQuery.access_token) {
            window.sessionStorage.setItem('access_token', hashQuery.access_token);
            const jwt = auth.getJWT();
            if (jwt) {
                window.sessionStorage.setItem('domain', jwt.iss);
            }
        } else {
            window.sessionStorage.removeItem('access_token');
        }
        browserHistory.replace(query.redirect_uri ? query.redirect_uri : '/');
    }

    render() {
        if (!this.state.error) {
            return (
                <div></div>
            );
        }

        return (
            <Container>
                <Row>
                    <Col>
                        <h1>Authentication Error</h1>
                        <p>There was a problem authenticating with DDX. The following message was returned from the server:</p>
                        <blockquote>{this.state.error}</blockquote>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default Auth;
